/*
 * SearchFilterCondition
 * @module components/Search/SearchFilter
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';
import * as R from 'ramda';

import { Input } from '~/components/Input';
import { Select } from '~/components/Select';

export type SearchFilterConditionProps = {
  value: string | number,
  parameter?: string,
  parameters?: { value: string | number, label: React$Node }[],
  condition?: string,
  conditions?: { value: string | number, label: React$Node }[],
  onChange: (string, number | string) => void,
};

const SearchFilterConditionWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  ${/* sc-selector */ Select}, div[role='input'] {
    flex: 1;
    min-width: 60px;
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;

    .react-select__control {
      margin-bottom: 0 !important;
    }
  }
`;

const SearchFilterConditionRuleWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 10px 0 20px;

  & > span {
    display: inline-flex;
    margin: 0 12px;
    font-size: 18px;
    font-weight: 600;
  }
`;

export const SearchFilterCondition = ({
  value,
  parameter,
  parameters,
  condition,
  conditions,
  onChange,
}: SearchFilterConditionProps) => {
  let conditionSign;

  switch (condition) {
    case 'EQ':
      conditionSign = '=';
      break;
    case 'GT':
      conditionSign = '>';
      break;
    case 'LT':
      conditionSign = '<';
      break;
    default:
      break;
  }

  return (
    <SearchFilterConditionWrapper testid="search-filter-condition">
      <Select
        options={parameters}
        // $FlowIssue
        value={R.find(R.propEq('value', parameter))(parameters)}
        onChange={({ value }) => onChange('parameter', value)}
      />
      {parameter && (
        <SearchFilterConditionRuleWrapper>
          <Select
            options={conditions}
            // $FlowIssue
            value={R.find(R.propEq('value', condition))(conditions)}
            onChange={({ value }) => onChange('condition', value)}
          />
          <span>{conditionSign}</span>
          <Input
            size="small"
            value={value}
            onChange={value => onChange('value', value)}
          />
        </SearchFilterConditionRuleWrapper>
      )}
    </SearchFilterConditionWrapper>
  );
};

SearchFilterCondition.defaultProps = {
  conditions: [],
  parameters: [],
};
